import * as React from "react";
import { observer } from "mobx-react";
import { WBSStore } from "modules/WBS/WBSStore";
import {
  Typography,
  withStyles,
  Collapse,
  ListItem,
  List,
  ListItemText,
  ListItemIcon,
} from "@material-ui/core";
import { SelectSimilar } from "common/icons";
import {
  KeyboardArrowRight,
  KeyboardArrowDown,
  ExpandLess,
  ExpandMore,
  Visibility,
  VisibilityOff,
} from "@material-ui/icons";
import i18n from "i18n";
import { DevelopmentStore } from "modules/development/DevelopmentStore";
import { Render3dStore } from "modules/render3D/Render3dStore";
import { RouteComponentProps } from "react-router";
import ToolBarItem from "modules/project/components/layouts/ToolBarItem";
import VisibilityIconOff from "@material-ui/icons/VisibilityOff";
import cone from "common/assets/images/cone.png";
import classNames from "classnames";
import { LibraryStore } from "modules/library/LibraryStore";
import { ERowType, EWBSView } from "common/enums";
import * as _ from "lodash";
import { toJS } from "mobx";
import { LoginStore } from "modules/login/LoginStore";

const styles = (theme) => ({
  container: {
    background: "linear-gradient(to bottom, #262527 85%, #000)",
    overflow: "auto",
    width: "250px",
  },
  title: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    backgroundColor: "#2E2E2E",
    color: "#ABC200",
    padding: "10px 18px",
    textTransform: "uppercase" as any,
  },
  level: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 700,
    backgroundColor: "#363637",
    color: "rgba(255,255,255,0.87)",
    minHeight: "28px",
    display: "flex",
    alignItems: "center",
    padding: "5px 10px",
    cursor: "pointer",
    marginBottom: "1px",
  },
  icon: {
    fontSize: "18px",
    color: "rgba(255,255,255,0.87)",
    marginRight: "5px",
    borderRadius: "9px",
    "&:hover": {
      backgroundColor: "#999",
    },
  },
  topBar: {
    backgroundColor: "#3A393E",
    height: "30px",
    display: "flex",
    alignItems: "center",
    padding: "0px 10px",
    color: "#dedede",
  },
  topBarText: {
    fontFamily: "Raleway",
    fontSize: "10px",
    fontWeight: 700,
    color: "#ABC200",
    letterSpacing: "1px",
    paddingLeft: "6px",
  },
  topBarWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: "10px",
    alignItems: "center",
  },
  texttitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    color: "#dedede",
  },
  text: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "#a8a8a8",
    padding: "5px",
    marginBottom: "0",
    marginTop: "2px",
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  tooltip: {
    width: "120px",
  },
  uploadText: {
    fontFamily: "Roboto",
    fontSize: "11px",
    color: "#A8A8A8",
    padding: "5px",
    letterSpacing: "0.5px",
    marginTop: "4px",
    fontWeight: "600" as any,
  },
  hoverList: {
    "&:hover": {
      "& > *": {
        display: "block !important",
        opacity: "0.6 !important" as any,
      },
    },
  },
  visibleIcon: {
    display: "block !important",
    transition: "all 0.2s ease-in",
    opacity: "0 !important" as any,
    "&:hover": {
      color: "rgba(255, 255, 255, 0.6)",
      opacity: "1 !important" as any,
    },
  },
  visibleIconActivity: {
    display: "block !important",
    transition: "all 0.2s ease-in",
    opacity: "1 !important" as any,
    "&:hover": {
      color: "rgba(255, 255, 255, 0.6)",
      opacity: "1 !important" as any,
    },
  },
  iconNew: {
    margin: 0,
    width: "30px",
    height: "30px",
    padding: "3px",
    alignItems: "middle",
  },
  provisorio: {
    background: "#363637",
    paddingLeft: "0",
    borderBottom: "1px solid black",
  },
  iconWrap: {
    padding: "0 2px",
  },
  iconUploadText: {
    border: "1px solid #1D1D1D",
    background: "#272727",
    padding: "0",
    textTransform: "uppercase" as any,
    borderRadius: "4px",
    transition: "all 0.3s",
    "&:hover": {
      background: "#353539",
    },
  },
  listicon: {
    color: "#dedede",
    size: "10px",
    padding: "0px",
    alignItems: "left",
  },
  listText: {
    color: "#dedede",
    size: "10px",
    padding: "0px",
    alignItems: "left",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap" as any,
    paddingLeft: "30px !important",
  },
  warning: {
    backgroundColor: "#ffa000",
  },
  progress: {
    margin: 0,
    color: "#ABC200",
  },
  table: {
    display: "table",
    height: "calc(100vh - 33px)",
  },
  tableCell: {
    display: "table-cell",
    verticalAlign: "middle",
    padding: "0 25px",
    textAlign: "center" as any,
  },
  stageTitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 700,
    color: "rgba(255,255,255,0.87)",
  },
  stageSubtitle: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 300,
    color: "rgba(255,255,255,0.67)",
  },
  list: {
    margin: "0px",
    overflow: "auto",
  },
  listNew: {
    margin: "0px",
    overflow: "auto",
    padding: 0,
  },
  ul: {
    padding: 0,
    display: "inline",
  },
  paper: {
    height: 0,
  },
  colorSwitchBase: {
    color: "#dedede",
    "&$colorChecked": {
      color: "#ABC200",
      "& + $colorBar": {
        backgroundColor: "#ABC200",
      },
    },
  },
  colorChecked: {
    color: "#ABC200",
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    height: "30px",
    margin: "5px 0",
    paddingTop: "5px",
    width: "100%",
  },
  nested: {
    paddingLeft: theme.spacing.unit * 5,
    background: "#363637",
    borderBottom: "1px solid black",
    paddingTop: "6px",
    paddingBottom: "6px",
    "&:hover": {
      "& > div:nth-child(2) > div >  svg": {
        opacity: 1,
      },
    },
  },
  iconVisible: {
    color: "rgba(255, 255, 255, 0.03)",
    fontSize: "18px",
    transform: `rotate(${0} deg)`,
    "&:hover": {
      color: "rgba(255, 255, 255, 0.6)",
    },
    transition: "all 0.3s ease-in",
    opacity: 0,
  },
});

type IProps = {
  classes: any;
  snack: any;
  match: RouteComponentProps<any>;
};

@observer
class Browser extends React.Component<IProps> {
  constructor(props) {
    super(props);
  }

  state = {
    developmentSeleted: "",
    selectedIndex: "",
    itemColapseMenu: new Array(),
    typesNavigation: new Array(),
  };

  componentWillMount() {
    this.getIfcTypes();
  }

  async getIfcTypes() {
    if (
      this.state.developmentSeleted !== DevelopmentStore.developmentSelected.id
    ) {
      this.setState({
        developmentSeleted: DevelopmentStore.developmentSelected.id,
      });
    }
  }

  handleListMenuClick = (event, index, item) => {
    this.handleColapseMenu(item);
  };

  handleListItemClick = async (event, index, modelId) => {};
  handleListItemDoubleClick = async (event, index, modelId) => {};

  handleColapseMenu(item: any) {
    var itemColapseMenu = this.state.itemColapseMenu;
    const ind = itemColapseMenu.indexOf(item);
    if (ind < 0) {
      itemColapseMenu.push(item);
    } else {
      itemColapseMenu.splice(ind, 1);
    }
    this.setState({ itemColapseMenu: itemColapseMenu });
  }

  setVisible = async (modelId) => {};
  setUnVisible = async (modelId) => {};

  compareItems(a, b) {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  }

  setUnVisibilityItens = async (e, item, key = "", _subType = false) => {
    Render3dStore.toolbarLoading = true;
    e.stopPropagation();
    e.preventDefault();
    let atualiza,
      visibility = Render3dStore.visibilityElement3D;
    atualiza = item.type;

    if (key === "") {
      atualiza = item.type;
    } else {
      atualiza = key;
    }
    let fator = visibility.indexOf(atualiza);
    if (fator !== -1) {
      visibility.splice(fator, 1);
    } else {
      visibility.push(atualiza);
    }
    Render3dStore.setTypesInvisible(visibility);
    Render3dStore.toolbarLoading = false;
  };

  handleScroll = (index) =>
    index === -1
      ? () => {
          WBSStore.setEAPTableScrollToIndex(0);
        }
      : (e) => {
          e.currentTarget.style.backgroundColor = "rgba(171, 194, 0, 0.2)";
          if (WBSStore.lineNavigator)
            WBSStore.lineNavigator.style.backgroundColor = null as any;
          WBSStore.lineNavigator = e.currentTarget;
          WBSStore.setSelectedLine(index, "description");
          WBSStore.setEAPTableScrollToIndex(index);
        };

  /** Retira os filhos do item do array da árvore de navegação de forma recursiva
   * @param rowId Id do item que será removido
   */
  deleteChildren(rowId: string) {
    let oldOpen = WBSStore.treeNavOpen;
    let oldIndex = oldOpen.findIndex((o) => o == rowId);
    oldOpen.splice(oldIndex, 1);

    let findInTreeObjs = WBSStore.treeObjs.find((t) => t.id == rowId);
    let findInTreeObjsIndex = WBSStore.treeObjs.findIndex((t) => t.id == rowId);

    if (rowId == "principal" || findInTreeObjs == undefined) {
      WBSStore.treeObjs = [];
      WBSStore.treeNavOpen = [];
      return;
    }

    if (findInTreeObjs) {
      WBSStore.treeObjs.splice(findInTreeObjsIndex, 1);
    }

    let findChildren = WBSStore.treeObjs.filter((t) => t.parentStage == rowId);

    if (findChildren.length > 0) {
      findChildren.forEach((c) => {
        this.deleteChildren(c.id);
      });
    }
  }

  /** Função para adicionar ou remover um item do array da árvore de navegação
   * @param row Item que será adicionado ou removido do array da árvore de navegação
   */
  handleToggle = (row) => (e) => {
    let oldOpen = WBSStore.treeNavOpen;
    let oldIndex = oldOpen.findIndex((o) => o == row.id);
    let findInTreeObjs = WBSStore.treeObjs.find((t) => t.id == row.id);
    if (oldIndex == -1) {
      if (!findInTreeObjs) {
        WBSStore.treeObjs.push({
          id: row.id,
          parentStage: row.data.parentStage,
        });
      }
      oldOpen.push(row.id);
    } else {
      this.deleteChildren(row.id);
    }
    this.killEvent(e);
    this.forceUpdate();
  };
  killEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  /**
   * Função recursiva para renderizar os itens da árvore de navegação
   *
   * @param rows Array de itens que serão renderizados
   * @returns
   */
  recursiveRenderLevels = (rows) => {
    const { classes } = this.props;
    rows = rows.filter((r) => r.data.rowType == ERowType.STAGE);
    let firstRowId = "principal";
    let data = { description: "Principal", parentStage: -1 };
    rows.unshift({ data, index: 0, id: firstRowId });
    return rows.map((row) => {
      let level = row.data.tree ? row.data.tree.split(".").length : 0;
      let index = row.index;
      let Icon =
        WBSStore.treeNavOpen.findIndex((o) => o == row.id) != -1
          ? KeyboardArrowDown
          : KeyboardArrowRight;
      if (row.data.description) {
        var descriptionFirstCharUppercase =
          row.data.description.toLowerCase().charAt(0).toUpperCase() +
          row.data.description.toLowerCase().slice(1);
      }

      if (
        row.id != firstRowId &&
        row.data.parentStage == -1 &&
        WBSStore.treeNavOpen.findIndex((o) => o == firstRowId) == -1
      ) {
        return <></>;
      }

      if (
        row.data.parentStage != -1 &&
        WBSStore.treeNavOpen.findIndex((o) => o == row.data.parentStage) == -1
      ) {
        return <></>;
      }

      return (
        <React.Fragment>
          <div
            key={row.id}
            style={{ paddingLeft: `${level * 15 + 10}px` }}
            className={classes.level}
            onClick={this.handleScroll(index)}
          >
            {row.id == firstRowId ||
            WBSStore.dataTable.findIndex(
              (dt) =>
                dt.data.parentStage == row.id &&
                dt.data.rowType == ERowType.STAGE
            ) != -1 ? (
              <Icon className={classes.icon} onClick={this.handleToggle(row)} />
            ) : (
              <div style={{ paddingLeft: `${23}px` }}></div>
            )}
            {descriptionFirstCharUppercase}
          </div>
        </React.Fragment>
      );
    });
  };

  filterNavigation() {
    // Caso ele tenha aberto o navegador antes de terminar de carregar, chama a função novamente
    if (Render3dStore.navigationLoaded == false) {
      setTimeout(() => {
        this.setState({ typesNavigation: this.filterNavigation() });
      }, 500);
      return [];
    }
    const typesNavigation = [...toJS(Render3dStore.typesNavigation)];
    const modelIdCollection: any = toJS(Render3dStore.modelIdCollection);
    let tmpTypesNavigation: any = [];
    let tmpItems: any = [];

    for (let j = 0; j < typesNavigation.length; j++) {
      // Filtra apenas os itens que tenham o id dentro do array de ifc ativos
      var objType = Object.keys(typesNavigation[j].items);
      for (let obj of objType.sort()) {
        for (let i = 0; i < modelIdCollection.length; i++) {
          if (
            typesNavigation[j].items[obj].id.findIndex(
              (itemsTypes) =>
                modelIdCollection[i] &&
                itemsTypes == (modelIdCollection[i] as any).tag
            ) != -1
          ) {
            tmpItems[obj] = typesNavigation[j].items[obj];
            break;
          }
        }
      }
      if (Object.keys(tmpItems).length > 0) {
        typesNavigation[j].items = tmpItems;
        tmpTypesNavigation.push(typesNavigation[j]);
        tmpItems = [];
      }
    }
    return tmpTypesNavigation;
  }

  componentDidMount() {
    Render3dStore.initVisibilityElement3D();
    this.setState({ typesNavigation: this.filterNavigation() });
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: any,
    snapshot?: any
  ): void {
    if (
      prevState.typesNavigation == this.state.typesNavigation &&
      prevState.typesNavigation.length == this.state.typesNavigation.length &&
      WBSStore.currentTab != EWBSView.EAP &&
      this.state.typesNavigation.length == 0
    ) {
      let filter = this.filterNavigation();
      if (
        filter.length > 0 &&
        this.state.typesNavigation.length != filter.length
      ) {
        this.setState({ typesNavigation: filter });
      }
    }
  }

  render3Dlist() {
    if (LibraryStore.changeVisibilty == true) {
      LibraryStore.handleFetchInVisibilityChange();
      LibraryStore.setChangeVisibilty(false);
    }
    const { classes } = this.props;
    const { itemColapseMenu, typesNavigation } = this.state;
    return (
      <React.Fragment>
        {LibraryStore.libraries.length > 0 &&
        Render3dStore.modelIdCollection.length > 0 ? (
          <div className={classes.list}>
            {typesNavigation.length > 0 ? (
              <List className={classes.listNew} disablePadding>
                <li key={`section`} className={classes.list}>
                  {typesNavigation.map((item, index) => (
                    <ul key={`section-${index}`} className={classes.ul}>
                      <ListItem
                        key={`item-${index}-${item.type}`}
                        button
                        onClick={(event) =>
                          this.handleListMenuClick(event, index, item.type)
                        }
                        style={{
                          width: "100%",
                          paddingTop: "6px",
                          paddingBottom: "6px",
                        }}
                        className={classes.hoverList}
                      >
                        {itemColapseMenu.indexOf(item.type) >= 0 ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        )}
                        {item.type}
                        <div
                          className={classes.visibleIcon}
                          style={{ position: "absolute", right: "25px" }}
                        >
                          <ToolBarItem
                            Icon={SelectSimilar}
                            action={async (e) => {
                              e.stopPropagation();
                              Render3dStore.selectSimilarElementsByTypeOrObjectType(
                                item.type,
                                ""
                              );
                            }}
                            fontColor={"rgba(255, 255, 255, 0.6)"}
                            fontSize={21}
                            title={i18n.viewer.toolbar.similar}
                            placement="bottom"
                          />
                        </div>
                        <div
                          id="visibleIcon"
                          className={
                            Render3dStore.visibilityElement3D.findIndex(
                              (el) => el === item.type
                            ) === -1
                              ? classes.visibleIcon
                              : classes.visibleIconActivity
                          }
                          style={{ position: "absolute", right: "2px" }}
                        >
                          {Render3dStore.visibilityElement3D.findIndex(
                            (el) => el === item.type
                          ) === -1 ? (
                            <ToolBarItem
                              Icon={Visibility}
                              action={async (e) => {
                                Render3dStore.setVisibilityElementsByTypeOrObjectType(
                                  item.type,
                                  false
                                );

                                this.setUnVisibilityItens(e, item);
                              }}
                              fontColor={"rgba(255, 255, 255, 1)"}
                              fontSize={21}
                              title={i18n.viewer.toolbar.makeUnvisible}
                              placement="bottom"
                            />
                          ) : (
                            <ToolBarItem
                              Icon={VisibilityOff}
                              action={async (e) => {
                                Render3dStore.setVisibilityElementsByTypeOrObjectType(
                                  item.type,
                                  true
                                );

                                this.setUnVisibilityItens(e, item);
                              }}
                              fontColor={"rgba(255, 255, 255, 1)"}
                              fontSize={21}
                              title={i18n.viewer.toolbar.makeVisible}
                              placement="bottom"
                            />
                          )}
                        </div>
                      </ListItem>
                      <Collapse
                        in={itemColapseMenu.indexOf(item.type) >= 0}
                        timeout="auto"
                        unmountOnExit
                      >
                        <List className={classes.listNew} disablePadding>
                          <li key={`section`} className={classes.list}>
                            {Object.keys(item.items).map((key, index) => (
                              <ul
                                key={`section-${index}`}
                                className={classes.ul}
                              >
                                <ListItem
                                  key={`items-${index}-${key}`}
                                  button
                                  onClick={(event) =>
                                    this.handleListMenuClick(
                                      event,
                                      index,
                                      `${key}-${index}`
                                    )
                                  }
                                  style={{
                                    width: "100%",
                                    minHeight: 36,
                                    paddingLeft: 50,
                                  }}
                                  className={classNames(
                                    classes.hoverList,
                                    classes.nested
                                  )}
                                >
                                  {" "}
                                  <div style={{ maxWidth: "90%" }}>
                                    {key.replace("Ifc", "")}
                                  </div>
                                  <div
                                    className={classes.visibleIcon}
                                    style={{
                                      position: "absolute",
                                      right: "25px",
                                    }}
                                  >
                                    <ToolBarItem
                                      Icon={SelectSimilar}
                                      action={async (e) => {
                                        Render3dStore.selectSimilarElementsByTypeOrObjectType(
                                          "",
                                          key
                                        );
                                      }}
                                      fontColor={"rgba(255, 255, 255, 0.6)"}
                                      fontSize={21}
                                      title={i18n.viewer.toolbar.similar}
                                      placement="bottom"
                                    />
                                  </div>
                                  <div
                                    id="visibleIcon"
                                    className={
                                      Render3dStore.visibilityElement3D.findIndex(
                                        (el) => el === key
                                      ) === -1
                                        ? classes.visibleIcon
                                        : classes.visibleIconActivity
                                    }
                                    style={{
                                      position: "absolute",
                                      right: "2px",
                                    }}
                                  ></div>
                                </ListItem>
                                <Collapse
                                  in={
                                    itemColapseMenu.indexOf(
                                      `${key}-${index}`
                                    ) >= 0
                                  }
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <List
                                    className={classes.listNew}
                                    disablePadding
                                  >
                                    {item.items[key].items
                                      .sort(this.compareItems)
                                      .map((comp, index) => (
                                        <ListItem
                                          key={`items-${index}-${comp.ifcLabel}`}
                                          button
                                          onClick={async (event) =>
                                            await this.handleListItemClick(
                                              event,
                                              index,
                                              comp.modelId
                                            )
                                          }
                                          onDoubleClick={async (event) =>
                                            await this.handleListItemDoubleClick(
                                              event,
                                              index,
                                              comp.modelId
                                            )
                                          }
                                          style={{ width: "100%" }}
                                          className={classes.nested}
                                          selected={false}
                                        >
                                          <ListItemText
                                            className={classes.listText}
                                            disableTypography
                                            inset
                                            primary={comp.name}
                                          />
                                          <ListItemIcon
                                            className={classes.listicon}
                                          >
                                            {Render3dStore.itemUnVisibilityList.findIndex(
                                              (i) =>
                                                i.GUID.indexOf(comp.GUID) < 0 &&
                                                i.modelId == comp.modelId
                                            ) < 0 ? (
                                              <ToolBarItem
                                                Icon={VisibilityIconOff}
                                                action={async () => {
                                                  await this.setUnVisible(
                                                    comp.modelId
                                                  );
                                                }}
                                                iconClass={classes.iconVisible}
                                                fontColor="rgba(255, 255, 255, 0.02)"
                                              />
                                            ) : (
                                              <ToolBarItem
                                                Icon={VisibilityIconOff}
                                                action={async () => {
                                                  await this.setVisible(
                                                    comp.modelId
                                                  );
                                                }}
                                                fontColor="rgba(255, 255, 255, 0.6)"
                                                fontSize={21}
                                              />
                                            )}
                                          </ListItemIcon>
                                        </ListItem>
                                      ))}
                                  </List>
                                </Collapse>
                              </ul>
                            ))}
                          </li>
                        </List>
                      </Collapse>
                    </ul>
                  ))}
                </li>
              </List>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <div className={classes.table} style={{ margin: "0 auto" }}>
            <div className={classes.tableCell} style={{ padding: 0 }}>
              <img src={cone} />
              <Typography className={classes.stageTitle} component="span">
                {i18n.viewer.navigator.empty.title}
              </Typography>
              <Typography className={classes.stageSubtitle} component="span">
                {i18n.viewer.navigator.empty.subtitle1}
              </Typography>
              <Typography className={classes.stageSubtitle} component="span">
                {i18n.viewer.navigator.empty.subtitle2}
              </Typography>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

  render() {
    const { classes } = this.props;
    const title =
      WBSStore.currentTab == EWBSView.EAP
        ? i18n.library.tabTitle
        : i18n.library.tabTitle3D;
    const isTrial = LoginStore.isTrialUser();

    let treeView = this.recursiveRenderLevels(WBSStore.dataTable);
    let render3Dlist = this.render3Dlist();

    return (
      <React.Fragment>
        <div>
          <Typography className={classes.title} component="div">
            {title}
          </Typography>
          <div
            className={classes.container}
            style={{ height: `calc(100vh - ${isTrial ? 103 : 68}px)` }}
          >
            {WBSStore.currentTab == EWBSView.EAP ? treeView : render3Dlist}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(Browser);



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/Browser.tsx